// Variables that should be constants that can be reused across the project
// Here are variables that are about the application itself where we don't want repeated all across the application
// use uppercase for constant that will never change
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9fc89d9c-1734-441f-bf83-cfe340121aa3';
export const MODAL_CLOSE_SEC = 2.5;
